// Action Types
export enum Types {
  LOAD_LOYALTY_REWARDS = 'loyalty/LOAD_LOYALTY_REWARDS',
  LOAD_LOYALTY_REWARDS_SUCCESS = 'loyalty/LOAD_LOYALTY_REWARDS_SUCCESS',
  LOAD_LOYALTY_REWARDS_FAILURE = 'loyalty/LOAD_LOYALTY_REWARDS_FAILURE',
  LOAD_LOYALTY_GOAL = 'loyalty/LOAD_LOYALTY_GOAL',
  LOAD_LOYALTY_GOAL_SUCCESS = 'loyalty/LOAD_LOYALTY_GOAL_SUCCESS',
  LOAD_LOYALTY_GOAL_FAILURE = 'loyalty/LOAD_LOYALTY_GOAL_FAILURE',
  LOAD_LOYALTY_HISTORY = 'loyalty/LOAD_LOYALTY_HISTORY',
  LOAD_LOYALTY_HISTORY_SUCCESS = 'loyalty/LOAD_LOYALTY_HISTORY_SUCCESS',
  LOAD_LOYALTY_HISTORY_FAILURE = 'loyalty/LOAD_LOYALTY_HISTORY_FAILURE',
  LOAD_LOYALTY_PRODUCT = 'loyalty/LOAD_LOYALTY_PRODUCT',
  LOAD_LOYALTY_PRODUCT_SUCCESS = 'loyalty/LOAD_LOYALTY_PRODUCT_SUCCESS',
  LOAD_LOYALTY_PRODUCT_FAILURE = 'loyalty/LOAD_LOYALTY_PRODUCT_FAILURE',
  LOAD_LOYALTY_PRODUCT_SIMULATE = 'loyalty/LOAD_LOYALTY_PRODUCT_SIMULATE',
  LOAD_LOYALTY_PRODUCT_SIMULATE_SUCCESS = 'loyalty/LOAD_LOYALTY_PRODUCT_SIMULATE_SUCCESS',
  LOAD_LOYALTY_PRODUCT_SIMULATE_FAILURE = 'loyalty/LOAD_LOYALTY_PRODUCT_SIMULATE_FAILURE',
  LOAD_LOYALTY_WITHDRAW = 'loyalty/LOAD_LOYALTY_WITHDRAW',
  LOAD_LOYALTY_WITHDRAW_SUCCESS = 'loyalty/LOAD_LOYALTY_WITHDRAW_SUCCESS',
  LOAD_LOYALTY_WITHDRAW_FAILURE = 'loyalty/LOAD_LOYALTY_WITHDRAW_FAILURE',
  LOAD_LOYALTY_SEND_WITHDRAW = 'loyalty/LOAD_LOYALTY_SEND_WITHDRAW',
  LOAD_LOYALTY_SEND_WITHDRAW_SUCCESS = 'loyalty/LOAD_LOYALTY_SEND_WITHDRAW_SUCCESS',
  LOAD_LOYALTY_SEND_WITHDRAW_FAILURE = 'loyalty/LOAD_LOYALTY_SEND_WITHDRAW_FAILURE'
}

export interface ILoyaltyState {
  rewards: ILoyaltyRewardsState;
  goal: ILoyaltyGoalState;
  history: ILoyaltyHistoryState;
  product: ILoyaltyProductState;
  simulate: ILoyaltyProductSimulateState;
  withdraw: ILoyaltyWithdrawState;
  send_withdraw: ILoyaltySendWithdrawState;
}

export interface ILoyaltyRewardTotals {
  client_id: string;
  total_coins: number;
  total_tonne: number;
}
export interface ILoyaltyRewardsResponse {
  total: ILoyaltyRewardTotals;
  monthly_coins: IMonthlyCoins[];
}

export interface ILoyaltyGoalResponse {
  monthly_goal: IMonthlyGoal[];
}

export interface ILoyaltyProduct {
  sku: string;
  description: string;
  activitySector: string;
}

export interface ILoyaltyProductResponse {
  product_search: ILoyaltyProduct[];
}

export interface ILoyaltyProductSimulateResponse {
  monthly_target: number;
  quarterly_target: number;
  simulation_tonne: number;
}

export interface ILoyaltyWithdrawBody {
  campaign_card: number;
  other_cards: number;
  cards_limit: number;
  activate_date: string;
}

export interface ILoyaltyWithdrawResponse {
  status: number;
  success: boolean;
  body: ILoyaltyWithdrawBody;
}

export interface ILoyaltySendWithdrawResponse {
  status: number;
  success: boolean;
  body: string;
}
export interface ILoyaltyHistoryResponse {
  history_body: IMonthlyHistory[];
}

interface ILoyaltyRewardsState extends ILoyaltyRewardsResponse {
  loading: boolean;
  error: boolean;
}

interface ILoyaltyGoalState extends ILoyaltyGoalResponse {
  loading: boolean;
  error: boolean;
}
interface ILoyaltyProductState extends ILoyaltyProductResponse {
  loading: boolean;
  error: boolean;
}
interface ILoyaltyProductSimulateState extends ILoyaltyProductSimulateResponse {
  loading: boolean;
  error: boolean;
}

interface ILoyaltyHistoryState extends ILoyaltyHistoryResponse {
  loading: boolean;
  error: boolean;
}

interface ILoyaltyWithdrawState extends ILoyaltyWithdrawResponse {
  loading: boolean;
  error: boolean;
}
interface ILoyaltySendWithdrawState extends ILoyaltySendWithdrawResponse {
  loading: boolean;
  error: boolean;
}

export interface IMonthlyCoins {
  start_date: string;
  client_id: string;
  coins: number;
  group_id: string;
}

export interface IMonthlyGoal {
  client_id: string;
  month: string;
  group_id: string;
  target: number;
}

export interface ILoyaltyProductList {
  product: ILoyaltyProduct;
  qty: number;
  qty_type: string;
}
export interface ILoyaltyProductListToSend {
  sku: string;
  qty: number;
  activity_sector: string;
}

export interface ILoyaltySendWithdrawBody {
  email: string;
  beneficiaries: ILoyaltyWithdrawBeneficiary[];
}

export interface ILoyaltyWithdrawBeneficiary {
  order_type: string;
  name: string;
  cnpj: string;
  address: string;
  phone: string;
  card_value: number;
}

interface IMonthlyHistory {
  id: number;
  coins: number;
  created_at: string;
  updated_at: string;
  client_id: string;
  group_id: string;
  order_total: number;
  order_id: string;
  order_date: string;
}
